import styles from "./footer.module.css";
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";
import { MdLocationOn, MdPhone, MdEmail } from "react-icons/md";
import { HeadingTitle, Image } from "../../shared/index";
import { Link } from "react-router-dom";
import { BsYoutube } from "react-icons/bs";

const Footer = () => {
  const productLinks = [
    // { name: "Categories", path: "/categories" },
    { name: "Shop", path: "/shop" },
    { name: "About us", path: "/about" },
    { name: "Contact", path: "/contact" },
    // { name:"Admin Login", path:"/admin/login"}
  ];

  const policyLinks = [
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Refund Policy", path: "/refund-policy" },
    { name: "Terms and Conditions", path: "/terms-and-conditions" },
    { name: "Shipping Policy", path: "/shipping-policy" },
  ];

  const socialIcons = [
    {
      icon: <FaFacebookF />,
      label: "Facebook",
      url: "https://www.facebook.com/people/Vitauraofficial/61591452373501/",
    },
    // { icon: <FaTwitter />, label: "Twitter", url: "https://twitter.com" },
    {
      icon: <FaInstagram />,
      label: "Instagram",
      url: "https://www.instagram.com/vitauraofficial/",
    },
    {
      icon: <BsYoutube />,
      label: "YouTube",
      url: "https://www.youtube.com/@vitauraofficial",
    },
  ];

  const year = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <div className={styles.footer__wrapper}>
        {/* LOGO + SOCIAL */}
        <div className={styles.footerSection}>
          <div className={styles.logoBox}>
            <img
              src="/vitauralogo.jpg"
              alt="Vitaura Logo"
              style={{
                width: "120px",
                height: "40px",
                objectFit: "contain",
                display: "block",
                margin: "0 auto",
              }}
            />
            {/* <Image
              src={"VITAURA"}
              alt="Anuradha-logo"
              className={styles.anuradha__logo}
            /> */}
          </div>

          <p className={styles.description}>
            Vitaura Life Sciences Private Limited delivers science driven
            nutrition and wellness solutions, combining innovation, quality, and
            trust to support healthier lives worldwide .
          </p>

          <div className={styles.socialSection}>
            <span className={styles.socialTitle}>Follow Us On</span>
            <div className={styles.socialIcons}>
              {socialIcons.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialIcon}
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* PRODUCT LINKS */}
        <div className={styles.footerSection}>
          {/* <HeadingTitle text="OUR STORES" style={styles.sectionTitle} /> */}
          <ul className={styles.linkList}>
            {productLinks.map((item, index) => (
              <li key={index}>
                <Link to={item.path} className={styles.link}>
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* POLICY LINKS */}
        <div className={styles.footerSection}>
          {/* <HeadingTitle text="SHOP CATEGORIES" style={styles.sectionTitle} /> */}
          <ul className={styles.linkList}>
            {policyLinks.map((item, index) => (
              <li key={index}>
                <Link to={item.path} className={styles.link}>
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* CONTACT INFO */}
        <div className={styles.footerSection}>
          <HeadingTitle text="CONTACT US" style={styles.sectionTitle} />
          <div className={styles.contactInfo}>
            {/* <div className={styles.contactItem}>
              <MdLocationOn className={styles.contactIcon} />
              <span className={styles.contactText}>
                Address -  Kompally , Hyderabad - 500100
              </span>
            </div> */}
           <div className={styles.contactItem}>
  <MdPhone className={styles.contactIcon} />

  <a
    href="tel:+918019070584"
    className={styles.contactText}
  >
    Call Us: +91 8019070584
  </a>
</div>
           <div className={styles.contactItem}>
  <MdEmail className={styles.contactIcon} />

  <a
    href="mailto:info@vitaura.co.in"
    className={styles.contactText}
  >
    Email: info@vitaura.co.in
  </a>
</div>
          </div>
        </div>
      </div>
     <div className={styles.footerBottom}>
  <div className={styles.footerBottomContent}>
    <p>
      Copyright © {year} Vitaura Life Sciences Pvt Ltd.
    </p>

    <p>
      Developed by{" "}
      <a
        href="https://gdrbtechnologies.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        GDRB Technologies Pvt Ltd.
      </a>
    </p>
  </div>
</div>
    </footer>
  );
};

export default Footer;
